export default "__VITE_ASSET__4e9ba46c__"